export default __webpack_public_path__ + "static/media/marker-actor.d988150a.svg";